import { sfNavBarHide } from './tab-bar-hide.component';

export default angular
  .module('sfMobile.directives.tab-bar-hide', [
    'sfMobile.services.tabs',
    'sfMobile.services.pubsub',
  ])
  .directive('sfTabBarHide', sfNavBarHide).name;
